<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { flowThreadContextKey } from './flowThreadContext';
import NodeBadge from '../ui/NodeBadge.vue';
import NodeInlineField from '../ui/NodeInlineField.vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const context = inject(flowThreadContextKey);
const hasTitleValue = computed(() =>
  Boolean(props.node.config?.title?.trim?.())
);
</script>

<template>
  <div
    class="bg-[linear-gradient(135deg,rgba(37,211,102,0.15),rgba(18,140,126,0.08))] px-3 py-2.5"
  >
    <div class="flex items-center justify-end gap-2">
      <NodeBadge
        :label="t('MOBILE_CONVERSATION_FLOWS.EDITOR.NO_MATCH_BADGE')"
        variant="whiteSoft"
      />
    </div>
    <NodeInlineField
      v-if="isSelected"
      :model-value="node.config?.title || ''"
      :placeholder="node.label"
      variant="plainStrong"
      @update:model-value="context.updateNode({ title: $event })"
    />
    <div
      v-else
      class="mt-2 text-[13px] font-semibold"
      :class="hasTitleValue ? 'text-n-slate-12' : 'text-n-slate-9'"
    >
      {{ node.config?.title || node.label }}
    </div>
  </div>
</template>
